<div class="row">
  <div class="col-12" *ngIf="showCropp">
    <div class="settings-menu" [style.color]="colorText">
      <em
        [class]="containWithinAspectRatio ? 'fa fa-arrows-alt' : 'fa fa-expand'"
        (click)="toggleContainWithinAspectRatio()"
      ></em>
      <em class="fa fa-undo" (click)="rotateLeft()"></em>
      <em class="fa fa-undo voltear" (click)="rotateRight()"></em>
      <em class="fa fa-sort horizontal" (click)="flipHorizontal()"></em>
      <em class="fa fa-sort" (click)="flipVertical()"></em>
      <em class="fa fa-search-minus" (click)="zoomOut()"></em>
      <em class="fa fa-search-plus" (click)="zoomIn()"></em>
    </div>
  </div>
  <div [class]="showCropp ? 'col-6' : 'col-12'" class="center flex-column">
    <label
      class="center"
      for="labelLogo"
      [ngClass]="size == 1 ? 'label-size-1' : 'label-size-2'"
      [ngStyle]="getPreviewLabelStyle()"
    >
      <img
        [src]="returnImage()"
        [ngClass]="getImageClass()"
        style="width: 100%; height: 100%; object-fit: cover"
        alt="logo"
      />
    </label>
    <input
      id="labelLogo"
      (change)="fileChangeListener($event)"
      accept=".png, .jpg, .jpeg"
      type="file"
      style="display: none"
    />
    <small [style.color]="colorText"> {{'general.preview' | translate}} </small>
  </div>
  <div
    [class]="showCropp ? 'col-6 d-flex justify-content-center align-items-center' : 'col-12 d-none'"
  >
    <div style="width: 250px; height: 250px; overflow: hidden">
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [canvasRotation]="canvasRotation"
        [transform]="transform"
        [style.display]="showCropp ? null : 'none'"
        [containWithinAspectRatio]="containWithinAspectRatio"
        [aspectRatio]="aspectRatio"
        format="png"
        (imageLoaded)="imageLoaded()"
        (LoadedImage)="LoadedImage($event)"
        [onlyScaleDown]="true"
        [alignImage]="'left'"
        [roundCropper]="false"
        (imageCropped)="imageCropped($event)"
        (cropperReady)="cropperReady($event)"
        [cropperMinWidth]="'200px'"
        [cropperMinHeight]="'200px'"
        (loadImageFailed)="loadImageFailed()"
        [maintainAspectRatio]="true"
      >
      </image-cropper>
    </div>

    <div *ngIf="!imageChangedEvent" class="text-center">
      <small>{{'general.click-preview' | translate}}.</small>
    </div>
  </div>
</div>
